import React, { useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { set_loading } from "../../../redux/actions/LayoutAction";
import logo from "../../../assets/images/logo.png";
import { connect } from "react-redux";
import { set_vendor_data } from "../../../redux/actions/VendorShopAction";
import { toast } from "react-toastify";
import { Redirect, useParams } from "react-router-dom";
import MobileLayoutRenderer from "../../../pages/mobile/layout/MobileLayoutRenderer";
import { useTranslation } from "react-i18next";
import { set_country } from "../../../redux/actions/LayoutAction";
import { set_cart_items } from "../../../redux/actions/CartAction";
import { set_redirect_home } from "../../../redux/actions/NotFoundAction";
import "../../../assets/styles/component/mobile/Home/HomeMobile.scss";
import "react-toastify/dist/ReactToastify.css";
import pagesbannerimg from "../../../assets/images/footer-pages-banners/Terms-&-Conditions.jpg";

function SummerTermsAndConditionsComp(props) {
  // eslint-disable-next-line
  const [modalShow, setModalShow] = React.useState(true);
  let message = ""; // eslint-disable-next-line
  const { id } = useParams(); // eslint-disable-next-line
  const { t, i18n } = useTranslation();
  const [redirect, setRedirect] = useState({ value: false });
  // eslint-disable-next-line
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // eslint-disable-next-line
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  return (
    <MobileLayoutRenderer
      NavbarTop={false}
      BackBtn={false}
      CancelBtn={false}
      NavbarBottom={true}
    >
      <div className="home-mob">
        <div className="header">
          <div className="logo">
            <img src={logo} width="100%" height="100%" alt="" />
          </div>
          <div className="search">
            <RiSearchLine
              onClick={() =>
                setRedirect({ value: true, path: "all-categories" })
              }
            />
          </div>
        </div>

        <div className="body" style={{ background: "#F5F5F5" }}>

          <div className="content-wrapper all-page-container">
            <div
              className="footer-pages-content"
              style={{
                textAlign: "left",
              }}
            >
              <p>
                <span className="eidtermsheading" style={{ fontSize: '20px', fontFamily: 'Futura Heavy', color: '#003366', display: 'block', textAlign: 'center' }}>
                  ALISOUQ Summer Campaign Rewards – Terms & Conditions
                </span>
              </p>

              <b>Campaign Period:</b>
              <p>This promotion is valid from May 15, 2025, to June 14, 2025.</p>

              <b>Eligibility:</b>
              <ul>
                <li>Offer is valid only for registered customers on alisouq.com.</li>
                <li>Guest or unregistered users are not eligible for cashback rewards.</li>
                <li>Cashback applies to completed orders only (excluding VAT and delivery charges).</li>
              </ul>

              <b>Cashback Structure:</b>
              <table border="1" cellpadding="6" cellspacing="0">
                <thead>
                  <tr><th>Order Value (AED)</th><th>Cashback Amount</th></tr>
                </thead>
                <tbody>
                  <tr><td>AED 1 – 99</td><td>AED 2</td></tr>
                  <tr><td>AED 100 – 199</td><td>AED 5</td></tr>
                  <tr><td>AED 200 – 299</td><td>AED 10</td></tr>
                  <tr><td>AED 300 – 399</td><td>AED 20</td></tr>
                  <tr><td>AED 400+</td><td>AED 30</td></tr>
                </tbody>
              </table>

              <p><strong>Cashback Limit:</strong> Customers can receive up to AED 100 cashback per month during the campaign period.</p>

              <b>Cashback Credit & Usage:</b>
              <ul>
                <li>Cashback will be credited to the customer’s ALISOUQ Wallet within 7 days after the end of the 7-day return period.</li>
                <li>Cashback is valid for 60 days from the date it is credited.</li>
                <li>Cashback can be used for future purchases on the platform.</li>
                <li>A minimum order value of AED 250 (excluding VAT and delivery) is required to redeem cashback.</li>
                <li>Cashback cannot be exchanged for cash or transferred to other accounts.</li>
              </ul>

              <b>General Conditions:</b>
              <ul>
                <li>One cashback reward applies per order.</li>
                <li>This offer cannot be combined with other discounts, promotions, or coupon codes unless stated otherwise.</li>
                <li>ALISOUQ reserves the right to modify, suspend, or cancel the promotion at any time without prior notice.</li>
                <li>In case of refunds or cancellations, the corresponding cashback will be revoked.</li>
                <li>Fraudulent activity or misuse of the campaign may result in reward forfeiture and/or account suspension.</li>
                <li>In the event of any disputes, ALISOUQ’s decision will be final.</li>
              </ul>

              <b>Cancellation Policy:</b>
              <p>If the order or the item(s) that you want to cancel have not been shipped yet, you can contact customer support at <a href="mailto:customerservice@alisouq.com">customerservice@alisouq.com</a> or call +971543064845 (Sunday to Thursday, 8AM to 5PM and Saturday, 8AM to 12PM). Refunds are processed within 7-14 days after cancellation.</p>

              <b>Return Policy:</b>
              <ul>
                <li>You have 7 days from the day of delivery to return any item that meets our return policy.</li>
                <li>Items must be unused, in original sealed packaging, and returned with proof of purchase.</li>
                <li>Partial returns are allowed.</li>
              </ul>

              <b>Refund Process:</b>
              <ul>
                <li>For card/net banking payments: refunded via ALISOUQ Wallet within 24-48 hours after receiving the product.</li>
                <li>For cash on delivery: refunded via ALISOUQ Wallet within 24-48 hours after receiving the product.</li>
              </ul>

              <b>Voucher Cancellation:</b>
              <p>Discount vouchers are one-time use and cannot be reused if an order is cancelled.</p>

              <b>Non-returnable Items:</b>
              <ul>
                <li>Items damaged from misuse</li>
                <li>Items missing original packaging</li>
                <li>Used/altered products or free promotional items</li>
                <li>Customized products and brand-specified non-returnable items</li>
              </ul>

              <b>Damaged/Defective/Wrong Product:</b>
              <ol>
                <li>Email <a href="mailto:customerservice@alisouq.com">customerservice@alisouq.com</a> within 7 business days.</li>
                <li>Share order ID, issue details, and a product photo.</li>
                <li>Pickup occurs within 2–4 days, and refund/replacement is processed if returned in original condition.</li>
              </ol>

              <b>Partial Returns:</b>
              <p>Returns can be initiated per item in a multi-item order.</p>

              <b>VAT Refund:</b>
              <p>VAT will be included in the refund if proof of purchase is provided.</p>

              <b>Cash on Delivery Charge:</b>
              <p>An additional AED 10 will be charged for cash on delivery orders.</p>
            </div>
          </div>
        </div>
        {redirect.value && (
          <Redirect
            push
            to={{ pathname: redirect.path, state: redirect.state }}
          />
        )}
      </div>
    </MobileLayoutRenderer>
  );
}

const mapStateToProps = (state) => {
  return {
    // categories: state.home.categories,
    // products: state.vendor.products,
    // services: state.vendor.services,
    // sections: state.home.sections,
    // positionOne: state.home.positionOne,
    // positionTwo: state.home.positionTwo,
    // positionThree: state.home.positionThree,
    // positionFour: state.home.positionFour,
    // positionFive: state.home.positionFive,
    load: state.layout.loading,
    countryId: state.language.countryId,
    language: state.language.language,
    country: state.language.country,
    countryUrl: state.language.countryUrl,
    redirect: state.notFound.redirect,
  };
};

const mapDispatchToProps = {
  set_vendor_data,
  // set_home_categories,
  set_country,
  set_cart_items,
  set_redirect_home,
  set_loading,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummerTermsAndConditionsComp);
